// Opțiunile de select ale formularului de angajat (EmployeeDetails.vue). `value` rămâne valoarea
// stocată în DB; doar `title` trece prin i18n (RO/EN/RU), fără etichete hardcodate în componentă.

const option = (t, group, key, value) => ({ title: t(`employeeDetails.options.${group}.${key}`), value });

export const buildEmployeeFormOptions = (t) => ({
  status: [option(t, "status", "active", 1), option(t, "status", "inactive", 0)],
  role: [
    option(t, "role", "user", "user"),
    option(t, "role", "manager", "vacation-manager"),
    option(t, "role", "director", "director"),
    option(t, "role", "hr", "hr"),
  ],
  gender: [option(t, "gender", "female", "female"), option(t, "gender", "male", "male")],
  nationality: [
    option(t, "nationality", "moldovan", "Moldovean"),
    option(t, "nationality", "romanian", "Român"),
    option(t, "nationality", "other", "Altă naționalitate"),
  ],
  maritalStatus: [
    option(t, "maritalStatus", "married", "Casatorit"),
    option(t, "maritalStatus", "single", "Necasatorit"),
  ],
  contractType: [
    option(t, "contractType", "indefinite", "Nedeterminat"),
    option(t, "contractType", "fixed", "Determinant"),
  ],
});
